import * as StateLib from "@/Utils/StateLib";
import React, { Fragment } from "react";
import { useWSMgrContext } from "@/providers/WsMgrProvider";
import ContextualToolbarEditChart from "./ContextualToolbarEditChart";
import ContextualToolbarDefault from "./ContextualToolbarDefault";
import ContextualToolbarEditBackground from "./ContextualToolbarEditBackground";
import ContextualToolbarBoxLayoutEditor from "./ContextualToolbarBoxLayoutEditor";
import ContextualToolbarPlanning from "./ContextualToolbarPlanning";
import { isNullish } from "@theorgchartdev/storybook";
import { enumChartElement, enumUIModes } from "@coreapp/constants";
import { Globals } from "@coreapp/CoreApp/Globals";
import { isInBackgroundEditor } from "@coreapp/utils/isInBackgroundEditor";
import { isInViewManager } from "@coreapp/utils/isInViewManager";
import { isInStandardSubmode } from "@coreapp/utils/isInStandardSubmode";
import { IsBackgroundFile } from "@coreapp/utils/IsBackgroundFile";
import cx from "classnames";

export const GetToolbarStyle = fullScreen => {
  let style = {};
  let availableWidth = 600;
  const canvasRef = document.querySelector(".theCanvas");
  const appHeaderRef = document.querySelector(".appHeader");
  const toolbar = fullScreen ? appHeaderRef : canvasRef;
  if (toolbar) {
    const toolbarRect = toolbar.getBoundingClientRect();
    availableWidth = toolbarRect.width;
  }
  style.maxWidth = availableWidth + "px";
  style.overflowX = "auto";
  style.overflowY = "hidden";
  style.gap = "24px";
  return style;
};

export const RenderToolbarContent = () => {
  const doc = StateLib.GetDoc();
  return doc && doc.fCanvasRef && doc.fCanvasRef.IsShown();
};

const ContextualToolbar = ({ className = "" }) => {
  const { wsMgr } = useWSMgrContext();
  const workspaceMgr = StateLib.GetWSMgr();
  const activeDragPanel = workspaceMgr?.GetActiveDragPanel();
  let firstSelectedBox = null;
  let firstSelectedCell = null;
  let lineSelection = null;
  if (workspaceMgr) {
    firstSelectedBox = workspaceMgr.GetFirstSelectedBox(true);
    firstSelectedCell = workspaceMgr.GetFirstSelectedElement(enumChartElement.boxCell);
    lineSelection = workspaceMgr.GetFirstSelectedElement(enumChartElement.connectingLine);
  }

  const canvasSelection =
    (firstSelectedBox || firstSelectedCell || lineSelection) && isNullish(activeDragPanel);

  const appMode = Globals._uiConfig ? Globals._uiConfig.GetUIMode() : enumUIModes.chart;
  const inEditMode = appMode === enumUIModes.edit && isInStandardSubmode();
  const inViewMode = appMode === enumUIModes.chart && isInStandardSubmode();
  const inBackgroundEditMode = isInBackgroundEditor();
  const inBoxLayoutEditor = Globals._uiConfig.GetUIMode() === enumUIModes.boxlayouteditor;

  const inViewEditMode = isInViewManager();
  const inPlanningMode = appMode == enumUIModes.planning && isInStandardSubmode();

  const currentFilename = workspaceMgr?.GetFileName(true);
  const isBackground = currentFilename ? IsBackgroundFile(currentFilename) : false;

  const showBackgroundEditorToolbar = inBackgroundEditMode && !inBoxLayoutEditor;
  const showEditChartToolbar = canvasSelection && inEditMode && !showBackgroundEditorToolbar;
  const showPlanningToolbar = inPlanningMode && !showBackgroundEditorToolbar;
  const showDefaultToolbar =
    !showBackgroundEditorToolbar &&
    ((inViewMode && !isBackground) || (inEditMode && !canvasSelection) || inViewEditMode);

  //TODO: I think a switch would be suitable here.
  return (
    <nav className={cx("contextToolbar", className)} role="toolbar" aria-label="context toolbar">
      {showDefaultToolbar && <ContextualToolbarDefault isSelection={canvasSelection} />}
      {showEditChartToolbar && <ContextualToolbarEditChart isSelection={canvasSelection} />}
      {showPlanningToolbar && <ContextualToolbarPlanning isSelection={canvasSelection} />}
      {showBackgroundEditorToolbar && (
        <ContextualToolbarEditBackground isSelection={canvasSelection} />
      )}
      {inBoxLayoutEditor && <ContextualToolbarBoxLayoutEditor isSelection={canvasSelection} />}
    </nav>
  );
};

export default ContextualToolbar;
